/**
 * 根据客户端UA判断是否是爬虫
 */
export function isSpiderClient(ua?: string) {
  if (!ua && (typeof window === "undefined" || !navigator?.userAgent)) {
    return false;
  }

  const spiderIndicators = ["spider", "Spider", "bot", "Bot"];
  const userAgent = ua || navigator.userAgent;

  return spiderIndicators.some((indicator) => userAgent.includes(indicator));
}
